module.exports = __webpack_public_path__ + "img/00025.4f5ed2c3.webp";